import { DayTab } from '@/pages/CarePlanView/DayTab';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { patientId } = Route.useParams();
  return <DayTab patientId={patientId} />;
};

export const Route = createFileRoute('/_auth/care-plan/$patientId/day')({
  component: RouteComponent,
});
